<template>
  <div class="admin-request-display row">
    <div class="col-md-6">
      <div class="card card-primary mb-2">
        <div class="card-header">
          <span class="mr-1 fa" :class="typeIcon"></span>
          {{ adminRequest.request.requestType }}
          <span class="badge" :class="{
            'badge-success': adminRequest.request.actioned,
            'badge-danger': !adminRequest.request.actioned,
          }">
            {{ adminRequest.request.actioned ? 'Resolved' : 'Unresolved' }}
          </span>
        </div>
        <template class="list-group list-group-flush" v-if="adminRequest.request.actioned && adminRequest.request.ResolvedNote">
          <div class="list-group-item">
            <account-note-display :data="adminRequest.request.ResolvedNote"></account-note-display>
          </div>
        </template>
        <template class="list-group list-group-flush" v-if="adminRequest.request.requestType === 'Reservation Charge'">
          <reservation-costs
            :reservation="adminRequest.data.reservation"
            :created-breakdown="adminRequest.data.createdBreakdown">
          </reservation-costs>
        </template>
        <template class="list-group list-group-flush" v-if="adminRequest.request.requestType === 'Low Fuel Report'">
          <li class="list-group-item">
            <strong>Car:</strong> <router-link :to="{ path: '/fleet/vehicles/' + adminRequest.data.car.uuid }">{{ adminRequest.data.car.dropdownLabel }}</router-link>
          </li>
          <li class="list-group-item">
            <strong>Reported By:</strong> <router-link :to="{ path: '/membership/members/' + adminRequest.request.AccountUuid }">{{ adminRequest.request.Account.dropdownLabel }}</router-link>
          </li>
        </template>
        <template class="list-group list-group-flush" v-if="adminRequest.request.requestType === 'High KM'">
          <li class="list-group-item">
            <strong>Reported KM: </strong> {{ adminRequest.request.jsonRequest.km | pretty_number }}km
          </li>
        </template>
        <template class="list-group list-group-flush" v-if="!adminRequest.request.actioned && adminRequest.request.AccountNote">
          <div class="list-group-item">
            <account-note-display :data="adminRequest.request.AccountNote"></account-note-display>
          </div>
        </template>
        <div class="card-footer text-right" v-if="!adminRequest.request.actioned">
          <button type="button" class="btn btn-sm btn-success" @click="resolve()">
            <span class="fa fa-check"></span> Resolve
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <template v-if="adminRequest.data.reservation">
        <p class="alert alert-danger" v-if="adminRequest.backToBack">
          <span class="fa fa-exclamation-triangle"></span> Member had back to back bookings.
        </p>
        <reservation-display :data="adminRequest.data.reservation"></reservation-display>
        <car-availability class="mt-2" v-if="availability"
          :availability="availability"
          :car="adminRequest.data.reservation.Car"
          :date="adminRequest.data.reservation.startDate"
          @previous="previousAvailability()"
          @next="nextAvailability()"
          @change="changeAvailability($event)"
          :reservation="adminRequest.data.reservation.reservationId">
        </car-availability>
      </template>
    </div>
  </div>
</template>

<script>
import ReservationCosts from '@/components/displays/ReservationCosts'
import AccountNoteDisplay from '@/components/displays/AccountNoteDisplay'
import ReservationDisplay from '@/components/displays/ReservationDisplay'
import CarAvailability from '@/components/admin/CarAvailability.vue'
import { LOAD_ADMIN_REQUEST, OPEN_MODAL } from '@/vuex/types'
import { mapGetters } from 'vuex'
import { iconMap } from '@/util/helpers'
import Api from '@/vuex/api'

export default {
  name: 'AdminRequestDisplay',
  components: {
    AccountNoteDisplay,
    ReservationCosts,
    ReservationDisplay,
    CarAvailability
  },
  computed: {
    typeIcon () {
      for (let key in iconMap.AdminRequest) {
        if (this.adminRequest.request.requestType && this.adminRequest.request.requestType.includes(key)) {
          return iconMap.AdminRequest[key]
        }
      }
    },
    totalOustandingFee () {
      return parseFloat(this.adminRequest.data.reservation.lateFee) + parseFloat(this.adminRequest.data.reservation.kmFee)
    },
    ...mapGetters([
      'adminRequest'
    ])
  },
  data () {
    return {
      availability: false,
      availabilityDate: false,
      car: false
    }
  },
  watch: {
    async $route () {
      await this.$store.dispatch(LOAD_ADMIN_REQUEST, this.$route.params.problemUuid)
      let instance = new Api()
      if (this.adminRequest.data.reservation) {
        this.availabilityDate = moment(this.adminRequest.data.reservation.startDate).format()
        this.car = this.adminRequest.data.reservation.Car.uuid
        this.availability = await instance.getReservationAvailability(moment(this.availabilityDate).format('x'), this.car)
      }
    }
  },
  async mounted () {
    await this.$store.dispatch(LOAD_ADMIN_REQUEST, this.$route.params.problemUuid)
    let instance = new Api()
    if (this.adminRequest.data.reservation) {
      this.availabilityDate = moment(this.adminRequest.data.reservation.startDate).format()
      this.car = this.adminRequest.data.reservation.Car.uuid
      this.availability = await instance.getReservationAvailability(moment(this.availabilityDate).format('x'), this.car)
    }
  },
  methods: {
    resolve () {
      this.$store.dispatch(OPEN_MODAL, {
        permalink: 'resolveProblem',
        options: {
          title: 'Resolve Problem',
          actionLabel: 'Resolve'
        },
        params: this.$route.params
      })
    },
    async previousAvailability () {
      let instance = new Api()
      this.availabilityDate = moment(this.availabilityDate).subtract(1, 'days').format()
      this.availability = await instance.getReservationAvailability(moment(this.availabilityDate).format('x'), this.car)
    },
    async nextAvailability () {
      let instance = new Api()
      this.availabilityDate = moment(this.availabilityDate).add(1, 'days').format()
      this.availability = await instance.getReservationAvailability(moment(this.availabilityDate).format('x'), this.car)
    },
    async changeAvailability (date) {
      let instance = new Api()
      this.availabilityDate = moment(date).format()
      this.availability = await instance.getReservationAvailability(moment(this.availabilityDate).format('x'), this.car)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/AdminRequestDisplay.vue